import { connect } from 'react-redux'
import { selectors as backendSelectors } from '../../features/Backend'
import LegalTexts from '../../components/LegalTexts'

function mapStateToProps(state) {
    const locale = backendSelectors.getLocale(state)

    return {
        locale,
    }
}

export default connect(mapStateToProps, null)(LegalTexts)



// WEBPACK FOOTER //
// ./src/containers/LegalTexts/legal-texts.js